import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

// Placeholder questions — refine copy later.
const FAQS = [
  {
    q: "How does NEIV's AI visualization work?",
    a: "Customers upload a photo of their room, choose a product from your catalog, and NEIV's AI renders it into the real space in seconds — accurate lighting, perspective, and scale included.",
  },
  {
    q: "Do customers need to install an app?",
    a: "No. Everything runs in the browser. In-store customers simply scan a QR code and start visualizing on their own phone.",
  },
  {
    q: "Can I use my own product catalog?",
    a: "Yes. You can upload thousands of your own products, and every render uses only your catalog — keeping the experience fully on-brand.",
  },
  {
    q: "Which product categories are supported?",
    a: "Furniture, tiles, paint, wallpaper, lighting, curtains, flooring, and more — across kitchens, bathrooms, bedrooms, and living rooms.",
  },
  {
    q: "How do I get started?",
    a: "Sign up for a free trial or book a demo — we'll walk you through uploading your catalog and going live.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="bg-neutral-50 py-16 sm:py-20 md:py-24">
      <div className="mx-auto max-w-3xl px-4 md:px-8">
        <div className="text-center">
          <p className="text-sm font-bold uppercase tracking-widest text-primary">FAQ</p>
          <h2 className="mt-3 text-3xl font-bold text-neutral-900 md:text-4xl">
            Frequently asked questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12">
          {FAQS.map((faq, i) => (
            <AccordionItem
              key={faq.q}
              value={`faq-${i}`}
              className="mb-3 rounded-xl border border-neutral-200 bg-white px-6 shadow-sm shadow-neutral-900/[0.02]"
            >
              <AccordionTrigger className="text-left text-base font-semibold text-neutral-900 hover:no-underline">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-base leading-relaxed text-neutral-500">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
